var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-home",staticStyle:{"padding-bottom":"0px"}},[(_vm.userType !== 2)?_c('div',[_c('h2',[_vm._v("欢迎，"+_vm._s(_vm.userName))])]):[_c('product-list')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }